// extracted by mini-css-extract-plugin
export default {"noData":"noData___PC119","btn":"btn___CS8J1"};